(function(){
    angular
        .module('appback')
        .directive('ngMicrobiologia04Atb', microbiologia04Atb);

        microbiologia04Atb.$inject = ['ResultadosService','GenerallabService','$timeout'];
        function microbiologia04Atb(ResultadosService,GenerallabService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=microbiologia04atb.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.generalLab = GenerallabService;
						scope.existe_extrapolacion = false;
		            	if(!scope.item.resultado){
		            		scope.item.resultado = { extra : { resultado : { antibiogramas : [{}] }}};
			            }else{
			            	if(!scope.item.resultado.extra){
	                    		scope.item.resultado = { extra : { resultado : {antibiogramas : [{}] } } };
			            	}else{
			            		if(!scope.item.resultado.extra.resultado.antibiogramas){
			            			scope.item.resultado.extra.resultado.antibiogramas = [{}];
			            		}
			            	}
			            }

						scope.checkExtrapolado = function(){
							console.log("antes de checkExtrapolado",scope.existe_extrapolacion);
							console.log("antibiogramas",scope.item.resultado.extra.resultado.antibiogramas);
							scope.item.resultado.extra.resultado.antibiogramas.forEach(anti => {
								if (angular.isDefined(anti.antibiotico) && anti.antibiotico !== null) {
									Object.keys(anti.antibiotico).forEach(key => {
										let item = anti.antibiotico[key];
										if(angular.isDefined(item.extrapolado)){
											scope.existe_extrapolacion = true;
										}
									});
								}
							});
							console.log("despues de checkExtrapolado",scope.existe_extrapolacion);									
						}
						scope.checkExtrapolado();

	            		scope.antibioticos = [];
			            ResultadosService.getATB(scope.item.analitica_id,function(data){
	            			if(data.antibioticos.length>0){
	            				scope.antibioticos = data.antibioticos;
	            			}
			            });

			            scope.buscarInterpretacion = function(anti_id,micro_id,anti){
							//console.log("buscarInterpretacion",anti_id);
							var tecnica_id = scope.item.resultado.extra.resultado.antibiograma.tecnica_id;
							if(angular.isDefined(anti.antibiotico[anti_id]) && angular.isDefined(anti.antibiotico[anti_id].tecnica_id) && anti.antibiotico[anti_id].tecnica_id != ""){
								tecnica_id = anti.antibiotico[anti_id].tecnica_id;
							}
							if(typeof(anti.antibiotico[anti_id]) != 'undefined' && anti.antibiotico[anti_id].resultado == ""){
								//console.log("ENTRO");
								Object.keys(anti.antibiotico).forEach(key => {
									if (anti.antibiotico[key].atb_extrapolacion_id == anti_id) {
										delete anti.antibiotico[key];
									}
								});
							    delete anti.antibiotico[anti_id];
							}
			            	if(typeof(anti.antibiotico) != 'undefined' && typeof(anti.antibiotico[anti_id]) != 'undefined'){
								//console.log("ENTRO2", anti.antibiotico);
				            	ResultadosService.getIntAntibioticoMicro(anti_id,micro_id,tecnica_id,anti.antibiotico[anti_id].resultado,function(data){	
									anti.antibiotico[anti_id].interpretacion = data.interpretacion;
									Object.keys(anti.antibiotico).forEach(key => {
										let item = anti.antibiotico[key];

										if (item.extrapolado && item.atb_extrapolacion_id == anti_id) {
											/*if (angular.isDefined(item.resultado)) {
												delete item.interpretacion_extrapolado;
												//delete item.extrapolado;
												delete item.atb_extrapolacion_id;
											}*/
											// else {
												if(item.interpretacion_extrapolado!=anti.antibiotico[item.atb_extrapolacion_id].interpretacion){
													anti.antibiotico[key].extrapolado = false;
												}
												//delete anti.antibiotico[key];
											//}
										}
									});
									delete anti.antibiotico[anti_id].extrapolaciones;
			            			
									if(data.extrapolaciones.length>0){
										anti.antibiotico[anti_id].extrapolaciones = [];
										data.extrapolaciones.forEach(function(extrapolacion){
											if(angular.isArray(extrapolacion.atb_extrapolado)){
												extrapolacion.atb_extrapolado.forEach(function(atb_extrapolado){
													anti.antibiotico[anti_id].extrapolaciones.push({antibiotico_id:atb_extrapolado.id, antibiotico_code:atb_extrapolado.codigo, antibiotico_name:atb_extrapolado.nombre, interpretacion:anti.antibiotico[anti_id]["interpretacion"], seleccionado:false});
													if(angular.isUndefined(anti.antibiotico[atb_extrapolado.id])){
														anti.antibiotico[atb_extrapolado.id] = { iniciado : true};
													} 
													if(angular.isUndefined(anti.antibiotico[atb_extrapolado.id].extrapolado) && !scope.existe_extrapolacion){
														console.log("undefined extrapolado", atb_extrapolado);
														anti.antibiotico[atb_extrapolado.id].extrapolado = true;
													}
												});
											} else{
												anti.antibiotico[anti_id].extrapolaciones.push({antibiotico_id:extrapolacion.atb_extrapolado.id, antibiotico_code:extrapolacion.atb_extrapolado.codigo, antibiotico_name:extrapolacion.atb_extrapolado.nombre, interpretacion:anti.antibiotico[anti_id]["interpretacion"], seleccionado:false});
												if(angular.isUndefined(anti.antibiotico[extrapolacion.atb_extrapolado.id])){
													anti.antibiotico[extrapolacion.atb_extrapolado.id] = { iniciado : true };
												}
												if(angular.isUndefined(anti.antibiotico[extrapolacion.atb_extrapolado.id].extrapolado && !scope.existe_extrapolacion)){
													console.log("undefined extrapolado", extrapolacion.atb_extrapolado);
													anti.antibiotico[extrapolacion.atb_extrapolado.id].extrapolado = true;
												}
											}
										});
									}
									console.log("despues de buscar interpretacion", anti);
					            });
				            }
			            }

						scope.checkSeleccionado = function(extrapolado, anti, atb_extrapolacion_id,seleccionado){
							//console.log("checkSeleccionado",extrapolado, anti);
							if(seleccionado){
								if(!angular.isDefined(anti.antibiotico[extrapolado.antibiotico_id])){
									anti.antibiotico[extrapolado.antibiotico_id] = { iniciado : true };
								}
								anti.antibiotico[extrapolado.antibiotico_id].interpretacion_extrapolado = extrapolado.interpretacion;
								//anti.antibiotico[extrapolado.antibiotico_id].extrapolado = true;
								anti.antibiotico[extrapolado.antibiotico_id].atb_extrapolacion_id = atb_extrapolacion_id;
							} else {
								if(!angular.isDefined(anti.antibiotico) && !angular.isDefined(anti.antibiotico[extrapolado.antibiotico_id].resultado)){
									//delete anti.antibiotico[extrapolado.antibiotico_id];
								} else {
									//delete anti.antibiotico[extrapolado.antibiotico_id].interpretacion_extrapolado;
									//delete anti.antibiotico[extrapolado.antibiotico_id].extrapolado;
									//delete anti.antibiotico[extrapolado.antibiotico_id].atb_extrapolacion_id;
								}
							}
							//console.log("after check seleccionado",anti);
						}

						scope.getExtrapoladosCount = function(anti) {
							if (!anti || !anti.antibiotico) {
								return 0;
							}
							return Object.values(anti.antibiotico).filter(a => a && a.extrapolado).length;
						};

			            scope.contarResultados = function(anti){
			            	var contador = 0;
			            	angular.forEach(anti.antibiotico, function (value, key) { 
				               	if(value.resultado!=""){
				               		contador++;
				               	}
				            });   
				            return contador;
			            	////console.log(anti);
			            	//return Object.keys(anti.antibiotico).length;
			            }

			            scope.optionsMicroorganismos = { 
		            		ajax: {
		                        url: "/backend/resultadopeticion/select2microorganismo",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                    }

	                    scope.borrar = function(index){
	                    	scope.item.resultado.extra.resultado.antibiogramas.splice(index,1);
	                    }

	                    scope.nuevo = function(){
	                    	scope.item.resultado.extra.resultado.antibiogramas.push({});
	                    }

			        });
		        }
          }
      }
})();